module.exports = __webpack_public_path__ + "static/media/pricingV2.6aea0b54.mp4";